.root {
  position: relative;
  display: flex;
  align-items: center;
  line-height: 1;
  font-weight: bold;
}

.date {
  font-weight: lighter;
  margin-left: auto;
  padding-left: 10px;
}

.root ~ .root {
  margin-top: 20px;
}

.root ~ .root > .dot:before {
  content: '';
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  background: linear-gradient(90deg, rgba(150,150,150,0.25) 0%, rgba(0,0,0,0.25) 100%);
  height: 35px;
}
